/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Integration, Integration$inboundSchema } from "./integration.js";

export type GetIntegrationResult = {
  integration?: Integration | undefined;
};

/** @internal */
export const GetIntegrationResult$inboundSchema: z.ZodMiniType<
  GetIntegrationResult,
  unknown
> = z.object({
  integration: z.optional(Integration$inboundSchema),
});

export function getIntegrationResultFromJSON(
  jsonString: string,
): SafeParseResult<GetIntegrationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetIntegrationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetIntegrationResult' from JSON`,
  );
}
